import React,{useState, useEffect} from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import PropTypes from 'prop-types';
import './TagStyle.css';

const KeyCodes = {
    comma: 188,
    enter: 13,
  };
  
const delimiters = [KeyCodes.comma, KeyCodes.enter];

export default function TagBox(param) {

    const [tags, setTags] = useState([]);
    const [readCheck, setReadCheck] = useState(false);
    const [title, setTitle] = useState("");
    const [count, setCount] = useState(1);
    const [locationTemp, setLocationTemp] = useState({});

    useEffect(() => {
        if(param.tags !== undefined) {
            setTags(param.tags || []);
        }
        if(param.readCheck !== undefined) {
            setReadCheck(param.readCheck);
        }
        if(param.title !== undefined) {
            setTitle(param.title)
        }

    }, [param]);


    

    useEffect(() => {
        if(param.representive !== undefined && param.representive.id !== undefined) {
            handleAddition(param.representive);
        }
    }, [param.representive]);

    useEffect(() => {
    }, [count])

    useEffect(()=> {
        if(param.clear !== undefined) {
            setTags([]);
        }
    }, [param.clear])


    function handleDelete(i) {
        var temp = tags.filter((tag, index) => index !== i);
        var deleteTemp = tags.filter((tag, index) => index == i);
        setTags(temp);
        if(param.callbackDeleteTag !== undefined) {
            param.callbackDeleteTag(deleteTemp);
        }
    }

    function handleAddition(tag) {
        var temp = tags;
        temp.push(tag);
        setTags(temp);
        setCount(count+1);
        if(param.callbackLowTagList !== undefined) {
            param.callbackLowTagList(tags, param.dataNumber);
        }
        
    }

    
    return(
        <div>
                <ReactTags tags={tags}
                    placeholder={title} 
                    // suggestions={suggestions}
                    handleDelete={handleDelete}
                    handleAddition={handleAddition}
                    // handleDrag={handleDrag}
                    // delimiters={delimiters} 
                    autofocus={false}
                    readOnly={readCheck}
                    delimiters={delimiters}
                />
                
            </div>
    );
}

TagBox.propTypes = {
    title: PropTypes.string,
    tagList: PropTypes.array,
    readCheck: PropTypes.bool,
    representive: PropTypes.object,
    tags: PropTypes.array,
    callbackLowTagList: PropTypes.object,
    clear: PropTypes.bool
};